import React from "react";
import SectionHeader from "../../utilis/SectionHeader";
import { SlCalender } from "react-icons/sl";
import { FaCommentDots } from "react-icons/fa";

const BlogSection = () => {
  const content = [
    {
      img: "/image/blog-section/blog-1.jpg",
      title: "How Exchange Rate Effect Your Business Growth",
      badge: "Corporate",
    },
    {
      img: "/image/blog-section/blog-2.jpg",
      title: "How To Stop Currency From Being Overwhelmed",
      badge: "Consumer",
    },
    {
      img: "/image/blog-section/blog-3.jpg",
      title: "How To Transfer Money With International Debit Card",
      badge: "Finance",
    },
  ];

  return (
    <div className="blog_section section-padding">
      <div className="container px-sm-2 px-4">
        {/* HEADING SECTION */}
        <div className="row padding-bottom">
          <div className="col-lg-6 col-sm-10 mx-auto" data-aos="zoom-in">
            <SectionHeader
              subTitle="OUR BLOG"
              title="Keep Up To Date With Global Content From Our Trusted Team"
            />
          </div>
        </div>
        {/* CONTENT SECTION */}
        <div className="row g-4">
          {content.map((element, index) => {
            return (
              <div className="col-lg-4 col-sm-6" key={index} data-aos='fade-up'>
                <div className=" p-4 blog_card transition index-1 position-relative  bg-white rounded-4 shadow-sm overflow-hidden">
                  <div className="blog_img overflow-hidden rounded-4 position-relative">
                    <img
                      src={element.img}
                      className="img-fluid rounded-4 transition"
                      alt=""
                    />
                    <div className="badge">{element.badge}</div>
                  </div>
                  <div className="blog_body ">
                    {/* DATE SECTION */}
                    <ul className="list-unstyled d-flex gap-4 mt-2">
                      <li className="mb-2">
                        <span className="mb-0 me-2 text-green date">
                          <SlCalender />
                        </span>{" "}
                        <span className="mb-0 text-color date">May 22 , 2022</span>
                      </li>
                      <li className="mb-2">
                        <span className="mb-0 me-2 text-green date">
                        <FaCommentDots />
                        </span>{" "}
                        <span className=" date mb-0 text-color">May 22 , 2022</span>
                      </li>
                    </ul>
                    {/* TITLE SECTION */}
                    <h5 className="text-black fw-800 transition blog_title">{element.title}</h5>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default BlogSection;
